/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-04-02 14:57:22
 */
export default {
  codeSend: '/uc/login/send/phone/verifycode',
  codeLogin: '/uc/login/phone/verifycode',
  accountLogin: '/uc/login/account',
  userInfo: '/uc/identify/user/baseinfo',
  passSendCode: '/uc/identify/user/center/reset/password/send/verify/code',
  updatePass: '/uc/identify/user/center/update/password',
  phoneSendCode: '/uc/identify/reset/phone/send/verify/code',
  phoneVerifyCode: '/uc/identify/reset/phone/check/verify/code',
  updatePhone: '/uc/identify/reset/phone',
  userCenterInfo: '/uc/identify/user/baseinfo',
  hbsgslLogin: '/uc/login/hbsgsl',
  updateInfo: '/uc/update/info',
  uploadImg: '/third/api/huaWeiUpload/upload/img',
  qhSendMsg: '/uc/bind/send/phone/verifycode',
  qhSign: '/course/sail/activity/sign/collect',
  qhSignCollege: '/course/sail/activity/sign/college/list',
  jssdkSign: '/third/jssdk/sign',
  leaderPlanLogin: '/course/tzb/leader/plan/login',
  leaderPlanProduct: '/course/tzb/leader/plan/product/list',
  genVerifyCode: '/uc/gen/verify/code',
}
